import React from "react";

function JRPremiumSales() {
  return <div>JRPremiumSales</div>;
}

export default JRPremiumSales;
